import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import LinkBudgetToUserGroup from './link-budgets-to-user-group/link-budget-to-user-group.component';

const UserGroupCreate = lazy(() => import('../user-group/user-group-create/user-group-create.component'));
const UserGroupOverview = lazy(() => import('../user-group/user-group-overview'));
const UserGroupDetail = lazy(() => import('../user-group/user-group-detail/user-group-detail.component'));
const UserGroupUpdate = lazy(() => import('../user-group/user-group-update/user-group-update.component'));
const UserGroupMemberAdd = lazy(() => import('../user-group/user-group-member-add/user-group-member-add.component'));
const UserGroupGroupAdd = lazy(() => import('../user-group/user-group-group-add/user-group-group-add.component'));
const UserGroupMemberReorder = lazy(() => import('../user-group/user-group-member-reorder/user-group-member-reorder.component'));

export function UserGroupRoutes() {
    return (
        <Route path='user-groups'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <UserGroupOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <UserGroupCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':groupId'>
                <Route
                    index
                    path='detail'
                    element={
                        <AsyncComponent>
                            <UserGroupDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <UserGroupUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='members/add'
                    element={
                        <AsyncComponent>
                            <UserGroupMemberAdd />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='groups/add'
                    element={
                        <AsyncComponent>
                            <UserGroupGroupAdd />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='members/reorder'
                    element={
                        <AsyncComponent>
                            <UserGroupMemberReorder />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='add-budgets'
                    element={
                        <AsyncComponent>
                            <LinkBudgetToUserGroup />
                        </AsyncComponent>
                    }
                />
            </Route>
            <Route
                index
                element={<Navigate to='/user-groups' />}
            />
        </Route>
    );
}
